module.exports = __webpack_public_path__ + "static/media/bodiometer_desktop.13098310.mp4";